import { clsx } from "clsx";
import type { ReactNode } from "react";
import {
	Card,
	CardAction,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card.tsx";

export interface PanelProps {
	title: string;
	description?: string;
	action?: ReactNode;
	wide?: boolean;
	children: ReactNode;
}

export function Panel({
	title,
	description,
	action,
	wide,
	children,
}: PanelProps) {
	return (
		<Card className={clsx("dashboard-panel", wide && "is-wide")}>
			<CardHeader className="dashboard-panel__header">
				<CardTitle className="dashboard-panel__title">{title}</CardTitle>
				{description && (
					<CardDescription className="dashboard-panel__description">
						{description}
					</CardDescription>
				)}
				{action && (
					<CardAction className="dashboard-panel__action">{action}</CardAction>
				)}
			</CardHeader>
			<CardContent className="dashboard-panel__content">{children}</CardContent>
		</Card>
	);
}
